/**
 * Brand content
 */
export const BrandList = ['bunte', 'chip', 'focus', 'fitforfun'];
export const LegacyBrandList = ['bunte', 'chip', 'focus', 'fitforfun', 'praxistipps'];
export const CmsBrandMap = {
    'bunte-stack': 'bunte',
    escenic: 'focus',
    interred: 'chip',
};
export const BrandCmsMap = {
    bunte: 'bunte-stack',
    focus: 'escenic',
    chip: 'interred',
    fitforfun: 'vibe',
};
//# sourceMappingURL=enums.js.map